import {
  memo,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { GoDotFill } from "react-icons/go";
import { BsThreeDots } from "react-icons/bs";
import { LiaReplySolid } from "react-icons/lia";
import { IoChevronDownSharp, IoThumbsUp, IoThumbsUpOutline } from "react-icons/io5";
import { MdOutlineReport } from "react-icons/md";
import {
  Button,
  Collapse,
  Modal,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import { RiDeleteBinLine } from "react-icons/ri";
import {
  _imagesURL,
  adminBaseURL,
  DeleteCommentApi,
} from "../../constants/API";
import { authorize } from "../../shared/authorize";
import CommentShimmer from "../feeds/comments/CommentShimmer";
import ProfileAvatar from "../common/ProfileAvatar";
import axios from "axios";
import { Language, PostDetailContext } from "../../App";
import ReportModal from "../../pages/ReportModal";
import { toast } from "react-toastify";
import ImageComponent from "../common/ImageComponent";
import ImageShowModal from "../common/ImageShowModal";
import { useNavigate } from "react-router-dom";
import { PROFILE } from "../../constants/RoutesUrl";
import "../feeds/cards/PostFooter.css";

const CommentList = ({
  postComments,
  setPostComments,
  setReplyingTo,
  setParentId,
  parentId,
  setReplyId,
  replyId,
  captions,
  loader,
  handleGetComments,
  commentLoading,
  handleGetReplies,
  commentReplies,
  setCommentReplies,
  setShowReplies,
  showReplies,
  type,
  editWebinarTab,
  setSelectedPost,
  onClose,
  selectedImage,
  setSelectedImage,
}) => {
  const userData = localStorage.getItem("SignupData");
  const user = userData ? JSON.parse(userData) : null;
  const user_id = user?.data?.id;
  const postDetailContext = useContext(PostDetailContext);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [loadingId, setLoadingId] = useState(null);
  const [delLoader, setDelLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [likedComments, setLikedComments] = useState({});
  const [reportModal, setReportModal] = useState(false);
  const [reportId, setReportId] = useState("")
  const { lang } = useContext(Language);
    const navigate = useNavigate();

    // States for Image Preview in Modal
            const [isImagePreviewOpen, setIsImagePreviewOpen] = useState(false);
            const [previewImage, setPreviewImage] = useState("");
            const toggleImagePreview = () =>
              setIsImagePreviewOpen(!isImagePreviewOpen);
            const handleImageClick = (img) => {
              setPreviewImage(img); // Set the clicked image for preview
              toggleImagePreview();
            };

  const handleToggleMenu = (e, menuId) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenMenuId((prev) => (prev === menuId ? null : menuId));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".mr-cl-menu-wrapper")) {
        setOpenMenuId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Format timestamp to relative time
  const formatRelativeTime = (timestamp) => {
    const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });
    const now = Date.now() / 1000;
    const secondsAgo = Math.floor(now - timestamp);

    const intervals = [
      { label: lang?.second, value: 1, unit: 'second' },
      { label: lang?.minute, value: 60, unit: 'minute' },
      { label: lang?.hour, value: 3600, unit: 'hour' },
      { label: lang?.day, value: 86400, unit: 'day' },
      { label: lang?.month, value: 2592000, unit: 'month' },
      { label: lang?.year, value: 31536000, unit: 'year' },
    ];

    for (let i = intervals.length - 1; i >= 0; i--) {
      const interval = intervals[i];
      const diff = Math.floor(secondsAgo / interval.value);
      if (diff >= 1) {
        // Use the correct unit ('minute', 'second', etc.) for the Intl.RelativeTimeFormat
        return rtf.format(-diff, interval.unit);
      }
    }

    return rtf.format(-1, 'second');
  };

  // Format timestamp to compact short time (e.g. 7d, 2h, 15m) for mobile screens (< 500px)
  const formatShortRelativeTime = (timestamp) => {
    const now = Date.now() / 1000;
    const secondsAgo = Math.max(0, Math.floor(now - timestamp));

    if (secondsAgo < 60) return `${Math.max(1, secondsAgo)}s`;
    const minutesAgo = Math.floor(secondsAgo / 60);
    if (minutesAgo < 60) return `${minutesAgo}m`;
    const hoursAgo = Math.floor(secondsAgo / 3600);
    if (hoursAgo < 24) return `${hoursAgo}h`;
    const daysAgo = Math.floor(secondsAgo / 86400);
    if (daysAgo < 30) return `${daysAgo}d`;
    const monthsAgo = Math.floor(secondsAgo / 2592000);
    if (monthsAgo < 12) return `${monthsAgo}mo`;
    const yearsAgo = Math.floor(secondsAgo / 31536000);
    return `${yearsAgo}y`;
  };

  const handleReplyClick = (name, commentId, id) => {
    setReplyingTo(name);
    setParentId(commentId);
    setReplyId(id);
  };

  const toggleDeleteModal = (id, commentId) => {
    setDeleteModal(!deleteModal);
    setLoadingId(id);
    setParentId(commentId)
  };

  const handleDeleteComment = useCallback(async () => {
    setDelLoader(true);

    try {
      const response = await axios.get(
        `${DeleteCommentApi}${loadingId}`,
        authorize()
      );
      if (response.data.status) {
        setLoadingId("");
        setDeleteModal(false);
        handleGetComments();
        handleGetReplies(parentId);
        setDelLoader(false);
        if (postDetailContext?.postDetail && (postDetailContext.postDetail.id || postDetailContext.postDetail.original_id)) {
          postDetailContext.updatePostDetail({
            ...postDetailContext.postDetail,
            comments_count: Math.max(0, Number(postDetailContext.postDetail.comments_count || 0) - 1),
          });
        }
      }
    } catch (error) {
      console.error(error);
      setDelLoader(false);
    }
  }, [loadingId, handleGetComments, parentId, postDetailContext]);

  const handleCommentLike = async (commentId, currentLikes, isReply = false, parentCommentId = null) => {
    const previousLikedState = likedComments[commentId] || false;
    const isLiking = !previousLikedState;

    // Helper to update states (either optimistically or for reverting)
    const updateStates = (newLikedState) => {
      // Update like state
      setLikedComments(prev => ({...prev, [commentId]: newLikedState}));

      // Update count in the appropriate state
      if (isReply && parentCommentId) {
        setCommentReplies(prev => ({
          ...prev,
          [parentCommentId]: prev[parentCommentId].map(reply =>
            reply.id === commentId
              ? {...reply, likes_count: newLikedState ? reply.likes_count + 1 : Math.max(0, reply.likes_count - 1)}
              : reply
          )
        }));
      } else {
        setPostComments(prev => ({
          ...prev,
          data: prev.data.map(comment =>
            comment.id === commentId
              ? {...comment, likes_count: newLikedState ? comment.likes_count + 1 : Math.max(0, comment.likes_count - 1)}
              : comment
          )
        }));
      }
    };

    try {
      // Optimistically update UI
      updateStates(isLiking);

      // Make API call
      const url = `${adminBaseURL}user/post/comment/like/${commentId}`;
      const response = await axios.get(url, authorize());

      // Revert if needed
      const apiSucceeded = response.data.status &&
                          ((isLiking && response.data.action === "Comment liked") ||
                           (!isLiking && response.data.action === "Comment unliked"));

      if (!apiSucceeded) {
        updateStates(previousLikedState); // Revert to previous state
      }
    } catch (error) {
      console.error("Error liking comment/reply:", error);
      updateStates(previousLikedState); // Revert to previous state
      return null;
    }
  };

    const handlePostReport = useCallback(async (reportInput) => {
      if(!reportInput){
        toast.error("Please enter a report");
        return;
      }
      setIsLoading(true);
      try {
        const reportData = {
          feature_id: reportId,
          report: reportInput,
          type: "comment",
        };
        const response = await axios.post(`${adminBaseURL}app/report`, reportData, authorize());
        if (response.data.status) {
          toast.success("Reported Successfully!");
          setReportModal(false);
        } else {
          toast.error(response.data.action);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setIsLoading(false);
      }
    }, [ reportId, user_id]);

  return (
    <>
      <style>{`
        .mr-cl-row { padding: 10px 12px 2px; }
        .mr-cl-bubble {
          background: linear-gradient(135deg, #EBFBFE 0%, #F4FEFF 50%, #FFFFFF 85%);
          border: 1px solid #D7E0EA;
          border-radius: 18px 18px 18px 4px;
          padding: 9px 14px;
          display: inline-block;
          max-width: 100%;
          box-shadow: 0 3px 12px rgba(0, 0, 0, 0.04);
          transition: border-color 0.15s ease, box-shadow 0.15s ease;
        }
        .mr-cl-bubble--full {
          display: block;
          width: 100%;
          box-sizing: border-box;
        }
        .mr-cl-row:hover .mr-cl-bubble {
          border-color: #9BE4F2;
          box-shadow: 0 4px 16px rgba(29, 193, 221, 0.14);
        }
        .mr-cl-name {
          font-size: 13.5px;
          font-weight: 600;
          color: #0F172A;
          transition: color 0.15s ease;
        }
        .mr-cl-name:hover { color: #00BADA; }
        .mr-cl-text {
          font-size: 13.5px;
          color: #334155;
          line-height: 1.5;
          margin: 2px 0 0;
          word-wrap: break-word;
          word-break: break-word;
        }
        .mr-cl-mention {
          color: #00BADA;
          font-weight: 600;
          margin-right: 4px;
          white-space: nowrap;
        }
        .mr-cl-meta {
          padding-left: 6px;
        }
        .mr-cl-time {
          font-size: 11.5px;
          color: #94A3B8;
          font-weight: 500;
        }
        .mr-cl-dot { color: #CBD5E1; }
        .mr-cl-action {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          background: transparent;
          border: none;
          padding: 3px 8px;
          border-radius: 999px;
          font-size: 12px;
          font-weight: 600;
          color: #64748B;
          cursor: pointer;
          transition: all 0.15s ease;
          line-height: 1;
        }
        .mr-cl-action:hover { background: #E8FBFF; color: #00BADA; }
        .mr-cl-action.is-liked { color: #00BADA; }
        .mr-cl-viewreplies {
          background: transparent;
          border: none;
          font-size: 12px;
          font-weight: 600;
          color: #00BADA;
          display: inline-flex;
          align-items: center;
          gap: 4px;
          cursor: pointer;
          padding: 3px 8px;
          border-radius: 999px;
          transition: background 0.15s ease;
        }
        .mr-cl-viewreplies:hover { background: #E8FBFF; }
        .mr-cl-dots {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          border: none;
          background: transparent;
          color: #94A3B8;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.15s ease;
        }
        .mr-cl-dots:hover { background: #F1F5F9; color: #0F172A; }
        .mr-cl-menu-dropdown {
          background: rgba(255, 255, 255, 0.98);
          backdrop-filter: blur(14px);
          -webkit-backdrop-filter: blur(14px);
          border-radius: 12px;
          border: 1px solid #E2E8F0;
          box-shadow: 0 10px 25px -5px rgba(15, 23, 42, 0.12), 0 4px 10px rgba(0, 0, 0, 0.04);
          padding: 4px;
          min-width: max-content;
          white-space: nowrap;
          animation: mrScaleUp 0.15s cubic-bezier(0.16, 1, 0.3, 1);
        }
        .mr-cl-menu-item {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 5px 10px;
          border-radius: 8px;
          cursor: pointer;
          white-space: nowrap;
          transition: all 0.15s ease;
        }
        .mr-cl-menu-item:hover {
          background: #FEF2F2;
        }
        .mr-cl-menu-icon {
          width: 24px;
          height: 24px;
          border-radius: 6px;
          background: #FEF2F2;
          color: #EF4444;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 13px;
          flex-shrink: 0;
          transition: all 0.15s ease;
        }
        .mr-cl-menu-item:hover .mr-cl-menu-icon {
          background: #EF4444;
          color: #FFFFFF;
        }
        .mr-cl-menu-label {
          font-size: 12.5px;
          font-weight: 600;
          color: #EF4444;
          margin: 0;
          line-height: 1;
          white-space: nowrap;
        }
        .mr-cl-time-short {
          display: none;
        }
        .mr-cl-time-full {
          display: inline;
        }
        .mr-cl-likes-text,
        .mr-cl-reply-text {
          display: inline;
        }
        @media (max-width: 500px) {
          .mr-cl-time-full {
            display: none !important;
          }
          .mr-cl-time-short {
            display: inline !important;
          }
          .mr-cl-likes-text,
          .mr-cl-reply-text {
            display: none !important;
          }
          .mr-cl-meta {
            flex-wrap: nowrap !important;
            gap: 3px !important;
            width: 100%;
          }
          .mr-cl-action {
            padding: 2px 4px !important;
            gap: 3px !important;
            font-size: 11.5px !important;
          }
          .mr-cl-viewreplies {
            padding: 2px 4px !important;
            font-size: 11px !important;
            white-space: nowrap !important;
            flex-shrink: 0 !important;
          }
          .mr-cl-row {
            padding: 4px 6px 1px !important;
          }
          .mr-cl-bubble {
            padding: 6px 10px !important;
            border-radius: 14px 14px 14px 4px !important;
          }
          .mr-cl-text {
            font-size: 12.5px !important;
            line-height: 1.35 !important;
          }
          .mr-cl-name {
            font-size: 12.5px !important;
          }
          .mr-cl-reply-row-wrap {
            padding-left: 20px !important;
          }
          .mr-cl-reply-line-h {
            width: 12px !important;
          }
          .mr-cl-reply-line-v {
            left: 8px !important;
          }
        }
        .mr-cl-reply-line-v {
          position: absolute;
          left: 19px;
          top: 0;
          bottom: 20px;
          width: 1px;
          background: #E2E8F0;
        }
        .mr-cl-reply-line-h {
          position: absolute;
          left: 19px;
          top: 60px;
          width: 24px;
          height: 1px;
          background: #E2E8F0;
        }
        .mr-cl-empty-icon {
          width: 52px;
          height: 52px;
          border-radius: 50%;
          background: #E8FBFF;
          color: #00BADA;
          border: 1px solid #BCEEFA;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .mr-cl-modal .modal-content {
          border-radius: 20px;
          overflow: hidden;
        }
      `}</style>
      <div
        className="my-2 scroll-hide"
        style={{
          height: "100%",
        }}
      >
        {commentLoading ? (
          [...Array(3)].map((_, index) => <CommentShimmer key={index} />)
        ) : postComments && postComments.data.length > 0 ? (
          postComments?.data.map((comment) => (
            <div key={comment.id} className="mr-cl-row">
              <div className="d-flex align-items-start gap-2">
                <ProfileAvatar
                  src={comment?.user?.image}
                  size={40}
                  variant="cyan"
                  alt={comment?.user?.name || "User"}
                  className="cursor flex-shrink-0"
                  onClick={() => { setSelectedPost(null); onClose(); editWebinarTab(false); navigate(PROFILE + "/" + comment?.user?.id); }}
                />
                <div className="flex-grow-1" style={{ minWidth: 0 }}>
                  <div className={`mr-cl-bubble ${!comment?.image ? "mr-cl-bubble--full" : ""}`}>
                    <span
                      className="mr-cl-name cursor"
                      onClick={() => { setSelectedPost(null); onClose(); editWebinarTab(false); navigate(PROFILE + "/" + comment?.user?.id); }}
                    >
                      {comment?.user?.name}
                    </span>
                    {comment?.image && (
                      <div className="mt-2">
                        <ImageComponent
                          compClassName="rounded-3 object-fit-cover cursor"
                          img_width={110}
                          img_height={110}
                          loader_width={110}
                          loader_height={110}
                          src={_imagesURL + comment?.image}
                          onClick={() => handleImageClick(_imagesURL + comment?.image)}
                          border="1px solid #E2E8F0"
                        />
                      </div>
                    )}
                    <p className="mr-cl-text">
                      {comment?.comment?.split('\n').map((line, index) => (
                        <span key={index}>{line}<br /></span>
                      ))}
                    </p>
                  </div>
                  <div className="d-flex align-items-center gap-1 mt-1 mr-cl-meta flex-wrap">
                    <span className="mr-cl-time">
                      <span className="mr-cl-time-full">
                        {formatRelativeTime(
                          Math.floor(new Date(comment.created_at).getTime() / 1000)
                        )}
                      </span>
                      <span className="mr-cl-time-short">
                        {formatShortRelativeTime(
                          Math.floor(new Date(comment.created_at).getTime() / 1000)
                        )}
                      </span>
                    </span>
                    <GoDotFill className="mr-cl-dot" size={4} />
                    <button
                      type="button"
                      className={`mr-cl-action ${likedComments[comment.id] ? "is-liked" : ""}`}
                      onClick={() => handleCommentLike(comment.id, comment.likes_count)}
                    >
                      {likedComments[comment.id] ? <IoThumbsUp size={13} /> : <IoThumbsUpOutline size={13} />}
                      <span>{comment.likes_count}</span>
                      <span className="mr-cl-likes-text">{lang?.likes}</span>
                    </button>
                    <button
                      type="button"
                      className="mr-cl-action"
                      onClick={() => { handleReplyClick(comment.user.name, comment.id, comment.user.id); setSelectedImage(null); }}
                    >
                      <LiaReplySolid size={14} />
                      <span className="mr-cl-reply-text">{lang?.reply}</span>
                    </button>
                    {comment.replies > 0 && (
                      <button
                        type="button"
                        className="mr-cl-viewreplies ms-auto"
                        onClick={() => handleGetReplies(comment.id)}
                      >
                        {showReplies[comment.id] ? lang?.hide : lang?.view}{" "}
                        {comment.replies} {lang?.replies}
                        <IoChevronDownSharp
                          size={12}
                          style={{
                            transform: showReplies[comment.id] ? "rotate(180deg)" : "rotate(0deg)",
                            transition: "transform 0.3s ease",
                          }}
                        />
                      </button>
                    )}
                  </div>
                </div>
                <div className="position-relative flex-shrink-0 mr-cl-menu-wrapper">
                  <button
                    type="button"
                    className="mr-cl-dots"
                    onClick={(e) => handleToggleMenu(e, `c-${comment?.id}`)}
                    aria-label="Comment options"
                  >
                    <BsThreeDots size={15} />
                  </button>
                  <Collapse
                    isOpen={openMenuId === `c-${comment?.id}`}
                    className="position-absolute"
                    style={{ right: "0", top: "30px", zIndex: 30 }}
                  >
                    <div className="mr-cl-menu-dropdown">
                      {comment?.user?.id !== user_id ? (
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenMenuId(null);
                            setReportId(comment.id);
                            setReportModal(true);
                          }}
                          className="mr-cl-menu-item"
                        >
                          <span className="mr-cl-menu-icon">
                            <MdOutlineReport size={14} />
                          </span>
                          <p className="mr-cl-menu-label">
                            {lang?.report}
                          </p>
                        </div>
                      ) : (
                        <div
                          className="mr-cl-menu-item"
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenMenuId(null);
                            toggleDeleteModal(comment?.id);
                          }}
                        >
                          <span className="mr-cl-menu-icon">
                            <RiDeleteBinLine size={14} />
                          </span>
                          <p className="mr-cl-menu-label">
                            {lang?.delete_comment}
                          </p>
                        </div>
                      )}
                    </div>
                  </Collapse>
                </div>
              </div>

              {loader[comment.id]
                ? [...Array(2)].map((_, index) => (
                    <CommentShimmer key={index} />
                  ))
                : showReplies[comment.id] &&
                  (commentReplies[comment.id]?.length > 0 &&
                    commentReplies[comment.id].map((reply, index) => (
                      <div key={reply.id}>
                        <div className="ps-5 mt-2 position-relative mr-cl-reply-row-wrap">
                          <div className="mr-cl-reply-line-v"></div>
                          <div className="mr-cl-reply-line-h"></div>
                          <div className="d-flex align-items-start gap-2">
                            <ProfileAvatar
                              src={reply?.user?.image}
                              size={34}
                              variant="cyan"
                              alt={reply?.user?.name || "User"}
                              className="cursor flex-shrink-0"
                              onClick={() => { setSelectedPost(null); onClose(); editWebinarTab(false); navigate(PROFILE + "/" + reply?.user?.id); }}
                            />
                            <div className="flex-grow-1" style={{ minWidth: 0 }}>
                              <div className="mr-cl-bubble mr-cl-bubble--full">
                                <span
                                  className="mr-cl-name cursor"
                                  onClick={() => { setSelectedPost(null); onClose(); editWebinarTab(false); navigate(PROFILE + "/" + reply?.user?.id); }}
                                >
                                  {reply.user.name}
                                </span>
                                <p className="mr-cl-text">
                                  <span
                                    className="mr-cl-mention cursor"
                                    onClick={() => { setSelectedPost(null); onClose(); editWebinarTab(false); navigate(PROFILE + "/" + reply.mentions[0].id); }}
                                  >
                                    {lang?.reply_to} {reply?.mentions[0]?.name}
                                  </span>
                                  {reply.comment && (reply.comment.includes("\r\n") || reply.comment.includes("\n")) ? (
                                    reply.comment.split(/(?:\r\n|\r|\n)/g).map((line, idx) => (
                                      <span key={idx}>
                                        {line}
                                        <br />
                                      </span>
                                    ))
                                  ) : (
                                    reply.comment
                                  )}
                                </p>
                              </div>
                              <div className="d-flex align-items-center gap-1 mt-1 mr-cl-meta flex-wrap">
                                <span className="mr-cl-time">
                                  <span className="mr-cl-time-full">
                                    {formatRelativeTime(
                                      Math.floor(new Date(reply.created_at).getTime() / 1000)
                                    )}
                                  </span>
                                  <span className="mr-cl-time-short">
                                    {formatShortRelativeTime(
                                      Math.floor(new Date(reply.created_at).getTime() / 1000)
                                    )}
                                  </span>
                                </span>
                                <GoDotFill className="mr-cl-dot" size={4} />
                                <button
                                  type="button"
                                  className={`mr-cl-action ${likedComments[reply.id] ? "is-liked" : ""}`}
                                  onClick={() => handleCommentLike(reply.id, reply.likes_count, true, comment.id)}
                                >
                                  {likedComments[reply.id] ? <IoThumbsUp size={13} /> : <IoThumbsUpOutline size={13} />}
                                  <span>{reply.likes_count || 0}</span>
                                  <span className="mr-cl-likes-text">{lang?.likes}</span>
                                </button>
                                <button
                                  type="button"
                                  className="mr-cl-action"
                                  onClick={() => { handleReplyClick(reply.user.name, comment.id, reply.user.id); setSelectedImage(null); }}
                                >
                                  <LiaReplySolid size={14} />
                                  <span className="mr-cl-reply-text">{lang?.reply}</span>
                                </button>
                              </div>
                            </div>
                            <div className="position-relative flex-shrink-0 mr-cl-menu-wrapper">
                              <button
                                type="button"
                                className="mr-cl-dots"
                                onClick={(e) => handleToggleMenu(e, `r-${reply.id}`)}
                                aria-label="Reply options"
                              >
                                <BsThreeDots size={15} />
                              </button>
                              <Collapse
                                isOpen={openMenuId === `r-${reply.id}`}
                                className="position-absolute"
                                style={{ right: "0", top: "30px", zIndex: 30 }}
                              >
                                <div className="mr-cl-menu-dropdown">
                                  {reply?.user?.id !== user_id ? (
                                    <div
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setOpenMenuId(null);
                                        setReportId(reply.id);
                                        setReportModal(true);
                                      }}
                                      className="mr-cl-menu-item"
                                    >
                                      <span className="mr-cl-menu-icon">
                                        <MdOutlineReport size={14} />
                                      </span>
                                      <p className="mr-cl-menu-label">
                                        {lang?.report}
                                      </p>
                                    </div>
                                  ) : (
                                    <div
                                      className="mr-cl-menu-item"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setOpenMenuId(null);
                                        toggleDeleteModal(reply.id, comment.id);
                                      }}
                                    >
                                      <span className="mr-cl-menu-icon">
                                        <RiDeleteBinLine size={14} />
                                      </span>
                                      <p className="mr-cl-menu-label">
                                        {lang?.delete_reply}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </Collapse>
                            </div>
                          </div>
                        </div>
                        {index === commentReplies[comment.id].length - 1 && (
                          <div style={{ height: "1px", background: "#F1F5F9", margin: "10px 12px 0" }} />
                        )}
                      </div>
                    ))
                  )}
            </div>
          ))
        ) : (
          <div
            className="text-muted m-0 p-0 d-flex flex-column align-items-center justify-content-center gap-2"
            style={{ height: type === "poll" ? "100%" : "59vh" }}
          >
            <div className="mr-cl-empty-icon">
              <LiaReplySolid size={22} />
            </div>
            <p className="m-0 roboto-bold" style={{ color: "#334155", fontSize: "14px", fontWeight: 600 }}>{lang?.no_comments_yet}</p>
            <p className="m-0" style={{ color: "#94A3B8", fontSize: "12.5px" }}>{lang?.no_comments_yet_para}</p>
          </div>
        )}

        {deleteModal && (
          <Modal
            isOpen={deleteModal}
            toggle={toggleDeleteModal}
            centered
            size="md"
            backdrop="static"
            contentClassName="mr-cl-modal"
          >
            <ModalBody className="px-3 pt-3">
              <h5 style={{ fontFamily: "'Onest', sans-serif", fontWeight: 600 }}>
                {lang?.do_want_delete_comment}
              </h5>
              <p style={{ fontFamily: "'Onest', sans-serif", fontWeight: 400 }}>
                {lang?.once_you_delete_comment_cannot_recover}
              </p>
            </ModalBody>
            <ModalFooter className="w-100 p-3">
              <Button
                className="cancel_btn rounded"
                onClick={() => setDeleteModal(!deleteModal)}
              >
                {lang?.cancel}
              </Button>
              <Button
                className="delete_btn rounded"
                onClick={handleDeleteComment}
              >
                {delLoader ? <Spinner size="sm" /> : lang?.yes_delete}
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </div>
      {reportModal && (
        <ReportModal
          isOpen={reportModal}
          toggle={setReportModal}
          handleReport={handlePostReport}
          isLoading={isLoading}
          heading={lang.report_post}
        />
      )}
      {isImagePreviewOpen &&
        <ImageShowModal
          isOpen={isImagePreviewOpen}
          toggle={toggleImagePreview}
          imageSrc={previewImage}
        />
      }
    </>
  );
};

export default memo(CommentList);
